import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { GroupTemplateFormData } from './group-template-form-data';
import {
  groupQueryString,
  parseQuery,
  RuleGroup,
} from '../../../../shared/query-builder-utils';
import MemberRestrictionFields from '../../../../shared/member-restriction-fields';
import ScopesAlert from '../../../../shared/scopes-alert';
import { doApiCheck, UserKeys } from '../../../../api/users-api';
import Skeleton from '@mui/material/Skeleton';

interface StepFourProps {
  control: Control<GroupTemplateFormData>;
  setValue: UseFormSetValue<GroupTemplateFormData>;
  watch: UseFormWatch<GroupTemplateFormData>;
}

export default function StepFour({ setValue, watch }: StepFourProps) {
  const initialSecurityQuery = watch('securityQuery') ?? '';
  const [ruleGroup, setRuleGroup] = useState<RuleGroup>(
    parseQuery(initialSecurityQuery)
  );

  const { data: accessGranted, isLoading: checkingApiAccess } = useQuery({
    queryKey: [UserKeys.AdminApiSettings, 'cloudIdentity'],
    queryFn: () => doApiCheck('cloudIdentity', null),
    staleTime: 0,
  });

  const handleRuleChange = (updatedGroup: RuleGroup) => {
    const newQueryString = groupQueryString(updatedGroup);
    setValue('securityQuery', newQueryString, { shouldDirty: true });
    setRuleGroup(updatedGroup);
  };

  if (checkingApiAccess) {
    return <Skeleton variant="rounded" height={120} />;
  }

  return accessGranted ? (
    <MemberRestrictionFields
      ruleGroup={ruleGroup}
      onRuleGroupChange={handleRuleChange}
      description="Select whether you want to restrict who can be members of groups created from this template."
    />
  ) : (
    <ScopesAlert apiKey="cloudIdentity" />
  );
}
